import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

import {
  faAngleUp, faAngleDown, faAngleLeft, faAngleRight,
  faArrowLeft, faArrowRight, faArrowRotateLeft, faArrowUpRight,
  faBars, faBath, faBed, faBedFront,
  faBellConcierge, faBoltLightning, faBriefcase, faBuilding,
  faCalculator, faCheck, faChild,
  faXmark,
  faCouch, faDoorClosed, faDrawSquare, faElevator,
  faEnvelope, faEuro, faFileArrowDown, faFire,
  faGear, faGrid2, faGrill,
  faHome, faHouse, faHouseBuilding, faImageSlash,
  faKey, faLabel, faList, faLocationDot, faLock,
  faMessage, faParking, faSquareParking, faPencil,
  faPerson, faPersonSwimming, faPhone, faSearch,
  faStairs, faStar, faToilet, faTree,
  faCalendar, faFilter, faHouseCircleCheck, faPeopleRoof,
  faPrint, faSort, faSortDown, faSortUp, faStore, faUser,
  faApartment, faCarGarage, faListCheck, faLocationDotSlash,
  faHouseChimney, faTractor,
  faBullseyePointer,
  faMap, faThumbsUp, faThumbsDown
} from '@awesome.me/kit-e8cfc819bb/icons/classic/regular'

import {
  faFacebook, faInstagram, faLinkedin, faTiktok, faXTwitter,
} from '@awesome.me/kit-e8cfc819bb/icons/classic/brands'

import { faIdeeri } from '@awesome.me/kit-e8cfc819bb/icons/kit-duotone/custom'

// icônes du site, par `${prefix}-${nom}` (nom principal et alias) : remplace la `library` de
// fontawesome-svg-core, qu'on n'embarque plus dans le JS client (voir Icon.tsx)
const definitions: IconDefinition[] = [
  faAngleUp, faAngleDown, faAngleLeft, faAngleRight,
  faArrowLeft, faArrowRight, faArrowRotateLeft, faArrowUpRight,
  faBars, faBath, faBed, faBedFront,
  faBellConcierge, faBoltLightning, faBriefcase, faBuilding,
  faCalculator, faCheck, faChild,
  faXmark,
  faCouch, faDoorClosed, faDrawSquare, faElevator,
  faEnvelope, faEuro, faFileArrowDown, faFire,
  faGear, faGrid2, faGrill,
  faHome, faHouse, faHouseBuilding, faImageSlash,
  faKey, faLabel, faList, faLocationDot, faLock,
  faMessage, faParking, faSquareParking, faPencil,
  faPerson, faPersonSwimming, faPhone, faSearch,
  faStairs, faStar, faToilet, faTree,
  faCalendar, faFilter, faHouseCircleCheck, faPeopleRoof,
  faPrint, faSort, faSortDown, faSortUp, faStore, faUser,
  faApartment, faCarGarage, faListCheck, faLocationDotSlash,
  faHouseChimney, faTractor,
  faFacebook, faInstagram, faLinkedin, faTiktok, faXTwitter,
  faIdeeri, faBullseyePointer, faMap, faThumbsUp, faThumbsDown
]

export const faIcons = new Map<string, IconDefinition>()

for (const definition of definitions) {
  const aliases = definition.icon[2].filter(alias => typeof alias === 'string')
  aliases.forEach(alias => faIcons.set(`${definition.prefix}-${alias}`, definition))
}
// un nom principal l'emporte sur l'alias d'une autre icône
definitions.forEach(definition => faIcons.set(`${definition.prefix}-${definition.iconName}`, definition))
